__turbopack_context__.v({
  "bolt": "kqmR4W_bolt",
  "container": "kqmR4W_container",
  "content": "kqmR4W_content",
  "job-offer-tag": "kqmR4W_job-offer-tag",
  "logo": "kqmR4W_logo",
  "pages": "kqmR4W_pages",
  "shape": "kqmR4W_shape",
  "socials": "kqmR4W_socials",
  "subscribe": "kqmR4W_subscribe",
  "terms-and-conditions": "kqmR4W_terms-and-conditions",
});
